var React = require('react');

function DoubleArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#09A5DB","fillRule":"evenodd","clipRule":"evenodd","opacity":".3"},[React.createElement("path",{"d":"M3.639 2.156a.689.689 0 0 1 .973-.973l4.332 4.33a.687.687 0 0 1 0 .973l-4.332 4.331a.688.688 0 1 1-.973-.974L7.483 6 3.639 2.156Z","key":0}),React.createElement("path",{"d":"M7.639 2.156a.689.689 0 0 1 .973-.973l4.332 4.33a.687.687 0 0 1 0 .973l-4.332 4.331a.688.688 0 1 1-.973-.974L11.483 6 7.639 2.156Z","key":1})]));
}

DoubleArrow.defaultProps = {"width":"12","height":"10","fill":"none"};

module.exports = DoubleArrow;

DoubleArrow.default = DoubleArrow;
